export default {
    // 停用
    stop: {
        title: 'public.stop',
        icon: 'el-icon-video-pause',
        // 点击后自动刷新列表
        reflash: true
    },
    // 编辑
    edit: {
        title: 'public.edit',
        icon: 'el-icon-edit-outline'
    },
    reuse: {
        title: 'public.reuse',
        icon: 'el-icon-refresh-right'
    },
    // 配置
    config: {
        title: 'public.details',
        icon: 'el-icon-setting'
    },
    // 详情
    detail: {
        title: 'public.tbopt_detail',
        icon: 'el-icon-tickets'
    },
    // 删除
    delete: {
        title: 'public.tbopt_delete',
        icon: 'el-icon-delete'
    },
    // 激活
    active: {
        title: $t('integration.click_sign_out'),
        icon: 'el-icon-open',
        reflash: true
    },
    // 失活
    inactive: {
        title: $t('integration.click_activate'),
        icon: 'el-icon-turn-off',
        reflash: true
    }
};
